import {type AnyFilterableDatatype, FilterableDatatype} from '../../types';
import type {ForceSetting} from 'shared/value-editors/kp-value-editor-force-settings/types';
import {exists} from 'shared/utils/custom-utils';

export function resolveDatatypeEditorForceSettings(filterableDatatype: AnyFilterableDatatype): ForceSetting {
    switch (filterableDatatype.name) {
        case FilterableDatatype.BOOLEAN:
            return {
                type: 'boolean',
                options: {}
            };

        case FilterableDatatype.DATE:
            return {
                type: 'date',
                options: {
                    onlyDate: true
                }
            };

        case FilterableDatatype.DATETIME:
            return {
                type: 'date',
                options: {
                    maximumGranularity: 'date-and-time',
                    viewFormat: 'd.L.y H:mm'
                }
            };

        case FilterableDatatype.DATETIME_RANGE:
            return {
                type: 'text',
                options: {}
            };

        case FilterableDatatype.NUMBER:
            return {
                type: 'number',
                options: {
                    min: filterableDatatype.min,
                    max: filterableDatatype.max
                }
            };

        case FilterableDatatype.TEXT:
            return {
                type: 'text',
                options: {
                    minLength: filterableDatatype.minLength
                }
            };

        case FilterableDatatype.CODEBOOK_VALUE:
            return {
                type: 'single-acceptable',
                options: {
                    acceptableValues: filterableDatatype.acceptableValues
                }
            };

        case FilterableDatatype.RECORD:
            return {
                type: 'inline-record-search',
                options: {
                    searchParams: {
                        rootFond: !exists(filterableDatatype.rootFond) || filterableDatatype.rootFond.length === 0 ? undefined : filterableDatatype.rootFond
                    },
                    searchType: 'q'
                }
            };
    }
}